import store from "@/store";
import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";
import portal from "@vacancorp/portal";

/** @remarks sort distance by histogram algorithm */
export function $_sortPlacesByVacancyOnMaps(vacancyList: PortalAdapterApi.ResponseGetMergedDisplayVacancy[]) {
  // set statusOrder
  vacancyList.forEach((vacancy: PortalAdapterApi.ResponseGetMergedDisplayVacancy) => {
    store.state.data.sortedPlaceList.forEach((place: portal.PublicPlaceWithVacancyId, index: number) => {
      if (vacancy.placeIdHash === place.placeIdHash) {
        const _place = place;
        _place.statusOrder = vacancy.statusOrder;
        store.commit("data/setSortedPlaceListIndex", {
          index,
          place: _place,
        });
      }
    });
  });
  // Sort place list by vacancy
  store.state.data.sortedPlaceList.sort(
    (placeA: portal.PublicPlaceWithVacancyId, placeB: portal.PublicPlaceWithVacancyId) => {
      return placeA.statusOrder - placeB.statusOrder;
    },
  );
}
export function $_sortPlacesByDistanceOnMaps() {
  if (!store.state.data?.selectedTopPlace?.location === undefined) return;

  // takes out statusOrder for keys
  const statusOrderList: number[] = store.state.data.sortedPlaceList.map(
    (place: portal.PublicPlaceWithVacancyId) => place.statusOrder,
  );
  // Create histogram array by statusOrderId
  const unDuplicated: number[] = [...new Set(statusOrderList)];

  const histogram: {
    statusOrder: number;
    data: portal.PublicPlaceWithVacancyId[];
  }[] = unDuplicated.map((statusOrderId: number) => {
    return { statusOrder: statusOrderId, data: [] };
  });
  // Push histogram
  histogram.forEach((obj: { statusOrder: number; data: portal.PublicPlaceWithVacancyId[] }) => {
    store.state.data.sortedPlaceList.forEach((place: portal.PublicPlaceWithVacancyId) => {
      if (place.statusOrder === obj.statusOrder) {
        obj.data.push(place);
      }
    });
  });
  // get distance
  let distanceArray: {
    placeIdHash: string;
    statusOrder: number;
    dist: number;
  }[] = store.state.data.sortedPlaceList.map((place: portal.PublicPlaceWithVacancyId) => {
    return {
      placeIdHash: place.placeIdHash,
      statusOrder: place.statusOrder,
      dist: store.getters["data/compareDistanceWithSelectedTopPlaceLocation"](place.location),
    };
  });
  // sort distance array
  distanceArray.sort((distA: { placeIdHash: string; dist: number }, distB: { placeIdHash: string; dist: number }) => {
    return distA.dist - distB.dist;
  });
  const result = _findPlaceByDistanceArray(histogram, distanceArray);
  store.commit("data/setSortedPlaceList", result);
}
export function $_sortPlacesByVacancy(
  sortedPlaceList: portal.PublicPlaceWithVacancyId[] | undefined,
  vacancyList: PortalAdapterApi.ResponseGetMergedDisplayVacancy[],
): portal.PublicPlaceWithVacancyId[] {
  if (sortedPlaceList === undefined) return [];
  vacancyList.forEach((vacancy: PortalAdapterApi.ResponseGetMergedDisplayVacancy) => {
    sortedPlaceList.forEach((place: portal.PublicPlaceWithVacancyId) => {
      if (vacancy.placeIdHash === place.placeIdHash) {
        place.statusOrder = vacancy.statusOrder;
      }
    });
  });
  // Sort place list by vacancy
  return sortedPlaceList.sort((placeA: portal.PublicPlaceWithVacancyId, placeB: portal.PublicPlaceWithVacancyId) => {
    return placeA.statusOrder - placeB.statusOrder;
  });
}
export function $_sortPlacesByDistance(
  sortedPlaceList: portal.PublicPlaceWithVacancyId[],
): portal.PublicPlaceWithVacancyId[] {
  if (!store.state.data.hasCurrentLocation || store.state.data?.location?.lat === undefined) return sortedPlaceList;

  const statusOrderList: number[] = sortedPlaceList.map((place: portal.PublicPlaceWithVacancyId) => place.statusOrder);
  // Create histogram array by statusOrderId
  const unDuplicated: number[] = [...new Set(statusOrderList)];
  const histogram: {
    statusOrder: number;
    data: portal.PublicPlaceWithVacancyId[];
  }[] = unDuplicated.map((statusOrderId: number) => {
    return { statusOrder: statusOrderId, data: [] };
  });
  // Push histogram
  histogram.forEach((obj: { statusOrder: number; data: portal.PublicPlaceWithVacancyId[] }) => {
    sortedPlaceList.forEach((place: portal.PublicPlaceWithVacancyId) => {
      if (place.statusOrder === obj.statusOrder) {
        obj.data.push(place);
      }
    });
  });
  // get distance
  let distanceArray: {
    placeIdHash: string;
    statusOrder: number;
    dist: number;
  }[] = sortedPlaceList.map((place: portal.PublicPlaceWithVacancyId) => {
    return {
      placeIdHash: place.placeIdHash,
      statusOrder: place.statusOrder,
      dist: store.getters["data/compareDistanceWithCurrentLocation"](place.location),
    };
  });
  // sort distance array
  distanceArray.sort((distA: { placeIdHash: string; dist: number }, distB: { placeIdHash: string; dist: number }) => {
    return distA.dist - distB.dist;
  });
  return _findPlaceByDistanceArray(histogram, distanceArray);
}
function _findPlaceByDistanceArray(
  histogram: { statusOrder: number; data: portal.PublicPlaceWithVacancyId[] }[],
  distanceArray: { placeIdHash: string; statusOrder: number; dist: number }[],
): portal.PublicPlaceWithVacancyId[] {
  let histogram2: {
    statusOrder: number;
    data: portal.PublicPlaceWithVacancyId[];
  }[] = histogram.map((obj: { statusOrder: number; data: portal.PublicPlaceWithVacancyId[] }) => {
    return {
      statusOrder: obj.statusOrder,
      data: [],
    };
  });

  histogram.forEach((obj: { statusOrder: number; data: portal.PublicPlaceWithVacancyId[] }, index: number) => {
    distanceArray.forEach((dist: { placeIdHash: string; statusOrder: number; dist: number }) => {
      const isFound: portal.PublicPlaceWithVacancyId | undefined = obj.data.find(
        (place: portal.PublicPlaceWithVacancyId) =>
          place.placeIdHash === dist.placeIdHash && place.statusOrder === dist.statusOrder,
      );
      if (isFound !== undefined) {
        histogram2[index].data.push(isFound);
      }
    });
  });

  let result = [] as portal.PublicPlaceWithVacancyId[];
  histogram2.forEach((obj: { statusOrder: number; data: portal.PublicPlaceWithVacancyId[] }) => {
    obj.data.forEach((d: portal.PublicPlaceWithVacancyId) => {
      result.push(d);
    });
  });

  return result;
}
